export default __webpack_public_path__ + "static/media/dubaiMap.79e89279.png";